<template>
    <div class="settings-page__service">
        <services ref="services" @ready="onReadeServices" @start="onStartServices" />
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartServices = (): void => {
        emit("data-loading", true);
    };
    const onReadeServices = (): void  => {
        emit("data-loading", false);
    };
</script>